export default __webpack_public_path__ + "static/media/011-lighthouse.0641eda1.svg";